export default {
      id: "ar_emploi-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ar_emploi-usage",
      toString: function () {
        return this.url;
      }
    }